/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Billing } from '../models/Billing';
import type { BillingSubscription } from '../models/BillingSubscription';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BillingService {
    /**
     * Get billing info
     * @param workspaceId Workspace ID required
     * @returns Billing Successfully retrieved billing
     * @throws ApiError
     */
    public static getBilling(
        workspaceId: string,
    ): CancelablePromise<Billing> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/billing',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Billing not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create subscription with redemption code
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @returns any Successfully created
     * @throws ApiError
     */
    public static postBilling(
        workspaceId: string,
        requestBody: {
            code: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/billing',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get plan usage
     * @param endpoint Endpoint ID required
     * @returns BillingSubscription Successfully retrieved usage
     * @throws ApiError
     */
    public static getBillingUsage(
        endpoint: string,
    ): CancelablePromise<BillingSubscription> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/billing/usage',
            query: {
                'endpoint': endpoint,
            },
            errors: {
                404: `Plan usage not found`,
                500: `Internal server error`,
            },
        });
    }
}
